import { Avatar } from "@a_team/ui-components";
import useBuilderAvatar from "hooks/useBuilderAvatar";

export const BuilderAvatar = ({ url }: { url: string }) => {
  const avatar = useBuilderAvatar(url);

  return <Avatar src={avatar} fill={true} />;
};
